import React, { useMemo } from "react"
import * as Yup from "yup"
import { EFormModule } from "../.."
import { useGetDealDoneByUsersQuery, useGetReasonsQuery } from "../../../../pages/Common/commonService"
import { useFormik } from "formik"
import { IProjectDetailsForm, setProjectDetailsForm } from "../../RaiseTicketFormSlice"
import { TStore } from "../../../../store/Store"
import { useDispatch, useSelector } from "react-redux"

type Props = {
    module: EFormModule
    handleNextStep: () => void
}

const validationSchema: (values: IProjectDetailsForm, dealType: string) => Yup.ObjectSchema<IProjectDetailsForm> = (values, dealType) => Yup.object().shape({
    project_name: Yup.string().required("Project Name is required"),
    deal_done_by: Yup.object().shape({
        id: Yup.number().required("Deal Done By is required"),
        title: Yup.string().required("Deal Done By is required"),
    }).required("Deal Done By is required"),
    project_closure_date: Yup.string().required("Project Closure Date is required"),
    deal_docs: Yup.mixed().required("Deal Docs is required"),
    purchase_order: dealType === "Outright" ? Yup.mixed().required("Purchase Order is required") : Yup.mixed().nullable(),
    reason: Yup.object().shape({
        id: Yup.number().required("Reason is required"),
        title: Yup.string().required("Reason is required"),
    }).required("Reason is required"),
})

const useProjectDetails = (props: Props) => {
    const dispatch = useDispatch()
    const { user_id } = useSelector((state: any) => state.verifyLogin)
    const { project_details_form, deal_sow_form } = useSelector((state: TStore) => state.RaiseTicketForm)

    const isOutright = deal_sow_form.deal_type?.title === "Outright"

    const { data: reasonsList } = useGetReasonsQuery({
        module_id: 2,
        submodule_id: 21,
    }, {
        skip: props.module !== EFormModule.DEMOLITION,
    })

    const { data: dealDoneByUsersList } = useGetDealDoneByUsersQuery()

    const formik = useFormik({
        initialValues: project_details_form,
        validationSchema: Yup.lazy((values: any) => validationSchema(values, deal_sow_form.deal_type?.title)),
        onSubmit: (values) => {
            dispatch(setProjectDetailsForm(values))
            props.handleNextStep()
        }
    })

    const dealDoneByUsersOptions = useMemo(() => {
        return dealDoneByUsersList?.map((dealDoneByUser: any) => ({
            id: dealDoneByUser.id,
            title: dealDoneByUser.name,
        }))
    }, [dealDoneByUsersList])

    const reasonOptions = useMemo(() => {
        return reasonsList?.filter(reason => reason.status && reason.reason_type === "Dismantle").map((reason: any) => ({
            id: reason.id,
            title: reason.reason,
        }))
    }, [reasonsList])

    const handleAssignToMe = () => {
        formik.setFieldValue("deal_done_by", {
            id: user_id,
            title: dealDoneByUsersList?.find((dealDoneByUser: any) => dealDoneByUser.id === user_id)?.name,
        })
    }

    return {
        reasonOptions,
        dealDoneByUsersOptions,
        formik,
        handleAssignToMe,
        isOutright
    }
}

export default useProjectDetails
